// Singleton audio element that persists across React lifecycle
// This prevents iOS from garbage collecting the audio stream when the PWA is backgrounded
let globalAudioElement: HTMLAudioElement | null = null;

export function getGlobalAudioElement(): HTMLAudioElement {
  if (!globalAudioElement) {
    globalAudioElement = document.createElement('audio');
    globalAudioElement.setAttribute('playsinline', 'true');
    globalAudioElement.preload = 'metadata';
    // Position off-screen but keep in DOM to prevent iOS garbage collection
    globalAudioElement.style.cssText = 
      'position:fixed;top:-9999px;left:-9999px;width:1px;height:1px;opacity:0;pointer-events:none';
    document.body.appendChild(globalAudioElement);
  }
  return globalAudioElement;
}

export function isAudioManagerInitialized(): boolean {
  return globalAudioElement !== null;
}
